import React from 'react';

import classes from './RecheduleContent.module.css';

import FlexModal from '../../UI/FlexModal/FlexModal';
import IconButton from '../../UI/IconButton/IconButton';
import FormFields from '../FormFields';
import Button from '../../UI/Button/Button';

import { IsObjectEmpty, IsStringEmpty, GetObjectClone } from '../../../utilities/CommonMethods';
import Input from '../../UI/Input/Input';

import closeIconBlack from '../../../assets/icons/icon-close-black.png';
import Wrapper from '../../../hoc/Wrapper/Wrapper';
import ShowLoader from '../../../hoc/ShowLoader/ShowLoader';
import checkboxChecked from '../../../assets/icons/checkbox-checked.png';
import checkboxUnchecked from '../../../assets/icons/checkbox-unchecked.png';
import { parseDateForInputField, parseTimeForInputField } from '../../../utilities/DateTimeUtils';

class RecheduleContent extends React.Component {

    state = {
        createNewTopicForm: GetObjectClone(FormFields.rescheduleContentForm),
        createNewTopicFormValid: false,
        errorMessage: '',
        showErrorMessage: false,
        showFormErrorMessage: false,
        formErrorMessage: '',
        showToolTip: false,
        includeWeekendsCheckbox: false,
        sendEmailsCheckbox: false,
    }

    checkRemainingCount = (value, inputIdentifier) => {
        var maxLength = this.state.createNewTopicForm[inputIdentifier].totalChar;
        var remainingCount = maxLength - value.length;
        return (remainingCount);
    }

    checkValidity = (formElement) => {
        let isValid = true;

        const rules = formElement.validation;
        let value = formElement.value;
        if (!IsObjectEmpty(formElement.validation)) {
            if (!IsObjectEmpty(rules.required) && rules.required.value) {
                isValid = (value.length > 0) && isValid;
                formElement.errorMessage = isValid ? '' : rules.required.errorMessage;
                formElement.valid = isValid;
            }
        }
        if (!IsObjectEmpty(rules.date)) {
            if (rules.date.value && !IsStringEmpty(value) && formElement.label === 'Rescheduled Date') {
                const parsedDate = IsStringEmpty(value) ? '' : new Date(value);
                if (IsStringEmpty(parsedDate)) { // Start Date cannot be empty
                    isValid = false && isValid;
                    formElement.valid = isValid;
                    formElement.errorMessage = isValid ? '' : 'Rescheduled date can not be empty';
                }
            }
        }

        return (formElement);
    }

    inputChangedHandler = (event, inputIdentifier) => {
        const updatedForm = { ...this.state.createNewTopicForm };
        let updatedFormElement = { ...updatedForm[inputIdentifier] };

        let inputValue = event.target.value;


        updatedFormElement.value = inputValue;
        updatedFormElement.touched = true;
        updatedFormElement = this.checkValidity(updatedFormElement, updatedForm);
        updatedFormElement.valid = updatedFormElement.valid
        updatedForm[inputIdentifier] = updatedFormElement;
        let formIsValid = true;

        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
            }

            this.setState({ createNewTopicForm: updatedForm, createNewTopicFormValid: formIsValid });
        }
    }

    onProceedButtonClick = () => {
        const updatedForm = { ...this.state.createNewTopicForm };
        for (let item in updatedForm) {
            updatedForm[item] = this.checkValidity(updatedForm[item], updatedForm);
        }

        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
            }
        }

        let formErrorMessage = '';

        this.setState({ createNewTopicForm: updatedForm, createNewTopicFormValid: formIsValid, showFormErrorMessage: !IsStringEmpty(formErrorMessage), formErrorMessage: formErrorMessage });
        if (formIsValid) {

            let rescheduleContentFormData = {
                "old_date": this.props.selectedDate,
                "new_date": this.state.createNewTopicForm['rescheduledDate'].value,
                "include_weekends": this.state.includeWeekendsCheckbox,
                "send_emails": this.state.sendEmailsCheckbox,

            };
            this.props.markDayOffClicked(rescheduleContentFormData);


        }
    }

    setFormData = () => {
        let updatedForm = { ...this.state.createNewTopicForm };

        let topicData = !IsObjectEmpty(this.props.data) ? this.props.data : {};
        if (!IsObjectEmpty(topicData)) {

            let currentDate = '', rescheduledDate = '';

            currentDate = !IsStringEmpty(topicData.scheduleDate) ? parseDateForInputField(new Date(topicData.scheduleDate)) : '';
            rescheduledDate = !IsStringEmpty(topicData.scheduleTime) ? parseTimeForInputField(topicData.scheduleTime) : '';

            // updatedForm['topicTitle'].value = topicName;
            updatedForm['currentDate'].value = currentDate;
            updatedForm['rescheduledDate'].value = rescheduledDate;

            this.setState({ createNewTopicForm: updatedForm });

        }
    }

    setScheduleDate = () => {
        let updatedForm = { ...this.state.createNewTopicForm };
        updatedForm['currentDate'].value = this.props.selectedDate;
        this.setState({ createNewTopicForm: updatedForm });
    }

    onIncludeWeekendsClicked = () => {
        this.setState({ includeWeekendsCheckbox: !this.state.includeWeekendsCheckbox })
    }
    onSendEmailsClicked = () => {
        this.setState({ sendEmailsCheckbox: !this.state.sendEmailsCheckbox })
    }

    componentDidMount() {
        // this.setFormData();
        if (!IsStringEmpty(this.props.selectedDate)) {
            this.setScheduleDate();
        }
    }


    inputFieldTopic = (key) => {
        return <Input
            inputIdentifier={key}
            elementType={this.state.createNewTopicForm[key].elementType}
            elementConfig={this.state.createNewTopicForm[key].elementConfig}
            label={this.state.createNewTopicForm[key].label}
            value={this.state.createNewTopicForm[key].value}
            disabled={this.state.createNewTopicForm[key].disabled}
            options={this.state.createNewTopicForm[key].options}
            changed={(event) => this.inputChangedHandler(event, key)}
            touched={this.state.createNewTopicForm[key].touched}
            afterText={this.state.createNewTopicForm[key].remainingChar}
            dropdownOpen={this.state.createNewTopicForm[key].dropdownOpen}
            onDropDownClick={() => this.onDropDownClick(key)}
            onDropDownItemClick={this.onDropDownItemClick}
            required={!IsObjectEmpty(this.state.createNewTopicForm[key].validation) ? (!IsObjectEmpty(this.state.createNewTopicForm[key].validation.required) ? this.state.createNewTopicForm[key].validation.required.value : false) : false}
            showError={(!this.state.createNewTopicFormValid && !this.state.createNewTopicForm[key].valid) ? true : false}
            error={this.state.createNewTopicForm[key].errorMessage}
        />
    }

    render() {
        return (
            <FlexModal visible={true} fullScreenMobile={true} backdropClicked={() => this.props.closePopup('')}>
                <div className={classes.CreateTopicFormContainer}>
                    <div className={classes.CloseIcon}>
                        <IconButton
                            styleclass='NoBorder SmallIcon'
                            icon={closeIconBlack}
                            altText='Close Icon'
                            clicked={() => this.props.closePopup('')}
                        />
                    </div>
                    <h3 className={classes.PopupHeading}>
                        Rechedule Content
                    </h3>

                    {this.props.showLoader
                        ? <div className={classes.FormLoaderContainer}>
                            <ShowLoader isLoading={this.props.showLoader} transparentBg={true} />
                        </div>
                        : <Wrapper>
                            <div className={[classes.FormInputHalf, classes.AddMarginRight].join(' ')} >
                                {this.inputFieldTopic('currentDate')}
                            </div>
                            <div className={[classes.FormInputHalf, classes.AddMarginRight].join(' ')}>
                                {this.inputFieldTopic('rescheduledDate')}
                            </div>

                            {
                                this.state.showFormErrorMessage
                                    ? <p className={classes.ErrorText}>{this.state.formErrorMessage}</p> : null
                            }

                            {/* <div className={classes.OngoingCurrently}>
                                <img src={this.state.includeWeekendsCheckbox ? checkboxChecked : checkboxUnchecked} alt='checkbox' onClick={this.onIncludeWeekendsClicked} />
                                <p onClick={this.onIncludeWeekendsClicked}>Include Weekends</p>
                            </div>
                            <div className={classes.OngoingCurrently}>
                                <img src={this.state.sendEmailsCheckbox ? checkboxChecked : checkboxUnchecked} alt='checkbox' onClick={this.onSendEmailsClicked} />
                                <p onClick={this.onSendEmailsClicked}>Send Emails</p>
                            </div> */}


                            <div className={classes.ButtonContainer}>
                                <Button
                                    styleclass="NonMobileOnly"
                                    label="RESCHEDULE"
                                    clicked={this.onProceedButtonClick}
                                    disabled={false}
                                    tooltip={null}
                                    margin="16px 20px 20px 0px"
                                />
                                <Button
                                    styleclass="MobileOnly"
                                    label="RESCHEDULE"
                                    clicked={this.onProceedButtonClick}
                                    disabled={false}
                                    tooltip={null}
                                    margin="0px"
                                    padding="1em 2em"
                                    fontSize="0.625em"
                                />
                            </div>
                        </Wrapper>
                    }
                </div>
            </FlexModal>
        );
    }
}

export default RecheduleContent;